import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const MbjTooltip = TooltipPrimitive.Root;
